import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BackendResponse,
  SchemaView,
  SchemaSidProperty,
} from '@qtek/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ProductSchemaService {
  private readonly http = inject(HttpClient);

  /**
   * Get product schema of product, which uses for item's settings, for ex. in item dialog
   *
   *
   *
   * @schema the product schema url from user.products[].schema
   * @returns {Observable<BackendResponse>}
   *
   */

  getProductSchemaById(schemaId: string): Observable<SchemaView> {
    return this.http.get<SchemaView>(
      '/api/v1/service/schema/' + btoa(schemaId),
      { withCredentials: true }
    );
  }

  getSchemasBySids(
    sids: string[]
  ): Observable<BackendResponse<Record<string, SchemaSidProperty[]>>> {
    return this.http.get<BackendResponse<Record<string, SchemaSidProperty[]>>>(
      '/api/v1/service/schemas/' + btoa(sids.toString()),
      {
        withCredentials: true,
      }
    );
  }
}
